import { ErrorMessageContents } from '../../helpers/hub'
import { BenchmarkInfo } from './types'

export const benchmarkDataFetch = () =>
  ({ type: 'benchmarkdata.fetch' } as const)
type BenchmarkDataFetchAction = ReturnType<typeof benchmarkDataFetch>

export const benchmarkDataFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'benchmarkdata.fetchFail', payload: error, error: true } as const)
type BenchmarkDataFetchFailAction = ReturnType<typeof benchmarkDataFetchFail>

export const getBenchmarkDataSuccess = (benchmarkInfo: BenchmarkInfo) =>
  ({ type: 'benchmarkdata.success', payload: benchmarkInfo } as const)
type BenchmarkDataSuccessAction = ReturnType<typeof getBenchmarkDataSuccess>

export const unsubscribeFromBenchmark = () =>
  ({ type: 'benchmarkdata.fetchCancel' } as const)
type BenchmarkDataFetchCancelAction = ReturnType<
  typeof unsubscribeFromBenchmark
>

export const setSecuritySearch = (gridIndex: number, search: string) =>
  ({
    type: 'benchmarkdata.setSecuritySearch',
    payload: { gridIndex, search }
  } as const)
type BenchmarkDataSetSecuritySearchAction = ReturnType<typeof setSecuritySearch>

export type BenchmarkDataAction =
  | BenchmarkDataFetchAction
  | BenchmarkDataFetchFailAction
  | BenchmarkDataFetchCancelAction
  | BenchmarkDataSuccessAction
  | BenchmarkDataSetSecuritySearchAction
